// Country Risk Register: the routes and the sidebar rows of `wealth.compliance.country-risk` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.country-risk',
    routes: [
        {
            frontend: 'comply',
            path: 'country-risk',
            lazy: () => import('@/pages/comply/country-risk/page'),
        },
    ],
    nav: [
        // SEP-228 §35 — the AML country risk register. Compliance maintains the
        // FATF grey list here, so a plenary change needs no code change.
        {
            frontend: 'comply',
            key: 'country-risk',
            label: 'Country Risk Register',
            href: '/comply/country-risk',
            icon: 'Globe',
            group: 'clients-kyc',
            order: 330,
        },
    ],
});
